// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-item {
    cursor: pointer;
    padding: 2px;
    width: 90px;
    height: 100px;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    overflow: hidden;
  
    border-radius: 4px;

    position: relative;

    background-color: #fcfcfc; 
}

.file-item .check-card {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

.file-item .check-icon {
    position: absolute;
    left: 4px;
    top: 2px;
    z-index: 2;
}


.file-item .check-icon * {
    font-size: 18px;
}

.file-item .check-icon .la.la-square {
    display: none;
    color: #fff;
}

.folder-icon em,
.file-icon em {
    font-size: 45px!important;
}


.list-icon.folder-icon em,
.list-icon.file-icon em {
    font-size: 20px!important;
}

.folder-icon {
    color: #FDDD34;
}

.file-img-icon {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 45px;
    width: 45px;
    border-radius: 4px;
}

.list-icon.file-img-icon {
    height: 20px;
    width: 20px;
}

.file-item.selected {
    background-color: #0d6efd;
    color: #fff;
}

.file-item.cutting {
    opacity: .6;
}


.file-item:not(.selected):hover {
    background-color: #e9ecef;
}

.file-item:not(.selected):hover .la.la-square {
    display: block;
}

.file-item .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-user-select: none;
            user-select: none;
    display: block;
    font-size: 12px;
    padding: 4px 0 0 0;
    text-align: center;
    width: 74px;
}

/* Context menu */

.context-menu {
    box-shadow: 0 16px 48px rgba(0,0,0,.175);
    padding: 4px 0;
    background-color: #fff;
    color: #212529;
    z-index: 1007;

    position: absolute;
}

.context-menu-option {
    cursor: pointer;
    position: relative;
    line-height: 30px;
    padding: 0 12px;
}

.context-menu-option:hover {
    background-color: #e9ecef;
}

.context-menu-option.disabled {
    opacity: .3;
}

.shared-item .isShare {
    position: absolute;
    top: 2px;
    right: 8px;
    color: #d2a055;
}`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/file-item.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;;IAEb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,kBAAkB;;IAElB,kBAAkB;;IAElB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,yBAAyB;AAC7B;;;AAGA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA,iBAAiB;;AAEjB;IACI,wCAAwC;IACxC,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,aAAa;;IAEb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,cAAc;AAClB","sourcesContent":[".file-item {\n    cursor: pointer;\n    padding: 2px;\n    width: 90px;\n    height: 100px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    overflow: hidden;\n  \n    border-radius: 4px;\n\n    position: relative;\n\n    background-color: #fcfcfc; \n}\n\n.file-item .check-card {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n}\n\n.file-item .check-icon {\n    position: absolute;\n    left: 4px;\n    top: 2px;\n    z-index: 2;\n}\n\n\n.file-item .check-icon * {\n    font-size: 18px;\n}\n\n.file-item .check-icon .la.la-square {\n    display: none;\n    color: #fff;\n}\n\n.folder-icon em,\n.file-icon em {\n    font-size: 45px!important;\n}\n\n\n.list-icon.folder-icon em,\n.list-icon.file-icon em {\n    font-size: 20px!important;\n}\n\n.folder-icon {\n    color: #FDDD34;\n}\n\n.file-img-icon {\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    height: 45px;\n    width: 45px;\n    border-radius: 4px;\n}\n\n.list-icon.file-img-icon {\n    height: 20px;\n    width: 20px;\n}\n\n.file-item.selected {\n    background-color: #0d6efd;\n    color: #fff;\n}\n\n.file-item.cutting {\n    opacity: .6;\n}\n\n\n.file-item:not(.selected):hover {\n    background-color: #e9ecef;\n}\n\n.file-item:not(.selected):hover .la.la-square {\n    display: block;\n}\n\n.file-item .file-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    user-select: none;\n    display: block;\n    font-size: 12px;\n    padding: 4px 0 0 0;\n    text-align: center;\n    width: 74px;\n}\n\n/* Context menu */\n\n.context-menu {\n    box-shadow: 0 16px 48px rgba(0,0,0,.175);\n    padding: 4px 0;\n    background-color: #fff;\n    color: #212529;\n    z-index: 1007;\n\n    position: absolute;\n}\n\n.context-menu-option {\n    cursor: pointer;\n    position: relative;\n    line-height: 30px;\n    padding: 0 12px;\n}\n\n.context-menu-option:hover {\n    background-color: #e9ecef;\n}\n\n.context-menu-option.disabled {\n    opacity: .3;\n}\n\n.shared-item .isShare {\n    position: absolute;\n    top: 2px;\n    right: 8px;\n    color: #d2a055;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
